var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{style:(_vm.iconStyle),attrs:{"src":_vm.iconSrc,"alt":"package-service-icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }